import xapi from "./xapi";
import {AxiosResponse} from "axios";
import {defineComponent} from 'vue'

declare global {
    interface Window {
        URL: any,
    }
}

export default defineComponent({

    name: "Helper",
    methods: {

        async readFileAsString(file: File): Promise<string | ArrayBuffer> {

            let reader = new FileReader();

            return new Promise((resolve) => {

                reader.onload = function (evt) {
                    if (evt.target.readyState != 2) return;
                    if (evt.target.error) {
                        alert('Error while reading file');
                        return;
                    }

                    resolve(evt.target.result);

                };

                reader.readAsText(file);

            });


        },

        async readFileAsDataUrl(file: File) {

            let reader = new FileReader();

            return new Promise((resolve) => {

                reader.onload = function (evt) {
                    if (evt.target.readyState != 2) return;
                    if (evt.target.error) {
                        alert('Error while reading file');
                        return;
                    }

                    resolve(evt.target.result);

                };

                reader.readAsDataURL(file);

            });


        },

        downloadFileObject(file): void {

            let fr = new FileReader();
            fr.readAsDataURL(file);
            let blob = new Blob([file], {type: file.type});

            let objectURL = window.URL.createObjectURL(blob);
            console.log(objectURL);

            let link = document.createElement('a');
            link.href = objectURL;
            link.download = file.name;
            document.body.appendChild(link);
            link.click();
            link.remove();

        },

        downloadStringAsFile($content, $filename): void {

            if (!$filename)
                throw 'Не задано имя скачиваемого файла';

            let blob = new Blob([$content]);

            let objectURL = window.URL.createObjectURL(blob);
            console.log(objectURL);

            let link = document.createElement('a');
            link.href = objectURL;
            link.download = $filename;
            document.body.appendChild(link);
            link.click();
            link.remove();

        },

        async downloadFileFromUrl($url): Promise<void> {

            let response = await xapi.getFile($url);
            let fileName = (response as AxiosResponse).headers["content-disposition"].split("filename=")[1];
            let filenameUtf8 = (response as AxiosResponse).headers["filename-utf-8"];
            let data = (response as AxiosResponse).data

            if (typeof data === 'object' && (!(data instanceof Blob)))
                data = JSON.stringify(data, null, 2);

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', (filenameUtf8) ? decodeURI(filenameUtf8) : fileName);

            document.body.appendChild(link);
            try {
                link.click();
            } catch (e) {
                link.remove();
            }

        },

        async printFileFromUrl($url): Promise<void> {

            let response = await xapi.getFile($url);

            const blob = new Blob([(response as AxiosResponse).data], {type: (response as AxiosResponse).data.type})
            const blobURL = window.URL.createObjectURL(blob);

            let iframe = document.createElement('iframe'); //load content in an iframe to print later

            document.body.appendChild(iframe);

            iframe.style.display = 'none';
            iframe.src = blobURL;
            iframe.onload = function () {
                iframe.onload = null;
                iframe.focus();
                iframe.contentWindow.print();
                setTimeout(() => {
                    iframe.remove();
                }, 3600 * 1000);
            };


        },

        isObject(A): boolean {
            return (typeof A === "object" || typeof A === 'function') && (A !== null);
        },

        objectToArray($obj) {

            if (!this.isObject($obj))
                return [];

            return Object.values($obj);
        },

        copyObjectByJSON(src) {
            return JSON.parse(JSON.stringify(src));
        },

        JSONparse($json) {
            $json = JSON.parse($json);
            return $json;
        },
        JSONstringify($json) {
            $json = JSON.stringify($json);
            return $json;
        },

        maxZIndex() {

            return [...document.querySelectorAll('body *')].reduce((accumulator, current_value: any) => {

                current_value = +getComputedStyle(current_value).zIndex;

                if (current_value === current_value) { // Not NaN
                    return Math.max(accumulator, current_value)
                }

                return accumulator;
            }, 0);


        },
        maxVisibleZIndex() {

            return [...document.querySelectorAll('body *')].reduce((accumulator, current_value: any) => {

                let computedStyle = getComputedStyle(current_value);

                if (!computedStyle.display || computedStyle.display === 'none') {
                    return accumulator;
                }

                current_value = +computedStyle.zIndex;

                if (current_value === current_value) { // Not NaN
                    return Math.max(accumulator, current_value)
                }

                return accumulator;
            }, 0);


        },

        convertTreeFromXBackendToPrimeTree(tree) {

            const convertOneItem = (item) => {

                let newItem: any = {};
                newItem.key = item.id + '';
                newItem.label = item.title;
                newItem.children = [];
                newItem.data = item;

                Object.values(item.items).forEach(childrenItem => {
                    newItem.children.push(convertOneItem(childrenItem));
                });

                return newItem;

            }

            let newTree = [];

            Object.values(tree.items).forEach(childrenItem => {
                newTree.push(convertOneItem(childrenItem));
            });

            return newTree;

        },
        convertTreeFromXBackendFlatToPrimeTree(dataset, keyProperty, labelProperty) {

            const hashTable = Object.create(null);
            dataset.forEach(aData => hashTable[aData.id] = {
                ...aData,
                children: [],
                key: aData[keyProperty],
                label: aData[labelProperty]
            });
            const dataTree = [];
            dataset.forEach(aData => {
                if (aData.parentId) hashTable[aData.parentId].children.push(hashTable[aData.id])
                else dataTree.push(hashTable[aData.id])
            });
            return dataTree;

        },

        getItemFromTreeById(branchNode, id) {

            const processOneNode = (OneNode, id) => {

                if (OneNode.data.id === id)
                    return OneNode;


                let res = null;
                OneNode.children.some(node => {
                    res = processOneNode(node, id);
                    if (res)
                        return res;
                });

                return res;

            }

            let res = null;

            branchNode.some(item => {
                res = processOneNode(item, id);
                if (res)
                    return res;
            });

            return res;

        },

        getObjectFromArrayByPropertyValue(arr, prop_name, prop_val) {

            return arr.find(item => {
                if (item?.[prop_name] === prop_val)
                    return item;
            })

        },

        mapArrayToSelectOptions(options: Array<any> | Object, title: string = 'title', value: string = 'value') {

            if (!options)
                return [];

            let arr = (typeof options === 'object') ? Object.values(options) : options;

            return arr.map((item: any) => {
                return {title: item[title], value: item[value]}
            });

        },

        isTrue: ($var: any) => ($var === true || ((typeof $var === 'string') && $var.toLowerCase() === 'true')),
        isFalse: ($var: any) => ($var === false || ((typeof $var === 'string') && $var.toLowerCase() === 'false')),

        htmlSpecialChars: (text) => {
            let map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };

            return text.replace(/[&<>"']/g, function (m) {
                return map[m];
            });
        },

        addSlashes: (string) => {
            return string.replace(/\\/g, '\\\\').replace(/\u0008/g, '\\b').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\f/g, '\\f').replace(/\r/g, '\\r').replace(/'/g, '\\\'').replace(/"/g, '\\"');
        },

        delay: (ms: number) => {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        sleep: async function (ms: number) {
            await this.delay(ms)
        },
        getPromise: () => {

            let resolve, reject
            return {
                promise: new Promise((res, rej) => {
                    resolve = res;
                    reject = rej;
                }),
                resolve: resolve,
                reject: reject,
            }

        }

    }

})